import {
    Chip,
    Collapse,
    Fade,
    LinearProgress,
    Stack,
    TableCell,
    TableHead,
    Typography,
} from '@mui/material';
import TableBody from "@mui/material/TableBody";
import { JobsHeaders } from 'Modules/Core/JobsTs/JobsConstants';
import { JobActions } from 'Modules/Core/JobsTs/JobsListTs/JobActions';
import { JobSummary } from 'Modules/Core/JobsTs/JobsListTs/JobSummary';
import { IJobRow, IJobsComponentBase, JobsSortCols } from 'Modules/Core/JobsTs/JobsModel';
import moment from "moment";
import { MouseEvent, useEffect, useState } from 'react';
import { ISortBase } from 'shared/SharedModels';
import {
    CollapsibleTableRow,
    RowSelectCell,
    ShAvatar,
    ShChip,
    ShTable,
    ShTableContainer,
    ShTableRow,
    ThemeColorDivider,
} from 'shared/SharedStyles/ShDataDisplay';
import { ShAlert } from 'shared/SharedStyles/ShFeedback';
import { ShCheckbox } from 'shared/SharedStyles/ShInputs';
import { PrimaryThemeColor, ShDarkGreen, ShGreen } from 'shared/SharedStyles/styleConstants';
import { getInitialsFromName, getUrlSearchParams, stringToColor, toTitleCase } from 'shared/utils';
import { ApplicantsCount } from './ApplicantsCount';
import { ShTableSortLabel } from './Jobs.styled';


// Table Row component
const Row = ({ getJobSummary, job, jobsSummary, selectJob, selectedJobs, jobsType, indx }: IJobRow) => {
    const [moreOptionsAnchorEl, setMoreOptionsAnchorEl] = useState<{ [key: number]: HTMLElement | null }>({ 0: null });
    const openMoreMenu = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>, indx: number) => {
        e.stopPropagation();
        setMoreOptionsAnchorEl({ ...moreOptionsAnchorEl, [indx]: e.currentTarget });
    };
    const hiringManagerInitials = getInitialsFromName(job?.hiring_manager || "SK", true, true); 
    const avatarBackgroundColor = stringToColor(hiringManagerInitials); 
   
    let remainingDays;
    let chipBgColor = '';
    let chipTextColor = '';

    if (jobsType === 'active') {
        const expirationDate = moment(job?.starts_at).add(30, 'days'); 
        remainingDays = expirationDate.diff(moment(), 'days');

        if (remainingDays <= 3) {
            chipBgColor = '#D32F2F'; 
            chipTextColor = 'white';
        } else if (remainingDays <= 8) {
            chipBgColor = '#F39C12'; 
            chipTextColor = 'white'; 
        } else if (remainingDays <= 30) {
            chipBgColor = ShDarkGreen; 
            chipTextColor = 'white'; 
        } else {
            chipBgColor = PrimaryThemeColor; 
            chipTextColor = 'white'; 
        }
    }
    
    return (<>
        <>
            <ShTableRow onClick={e => getJobSummary(job.id)} id={`j_t_v_r_${job.id}`}
                className={moreOptionsAnchorEl[job.id] ? 'is-actions-open' : ''} cursor='pointer'>
                <RowSelectCell onClick={(e) => e.stopPropagation()}>
                    <ShCheckbox id={'chk_' + indx} checked={selectedJobs?.includes(job.id)}
                        size='small' onChange={() => selectJob(job.id)} />
                </RowSelectCell>
                <TableCell padding='none'>
                    <ApplicantsCount job={job} usedIn='Table' jobsType={jobsType} />
                </TableCell>
                <TableCell>
                <Stack direction='row' alignItems='center' spacing={2}>
                    <Typography variant="body2">{job.name}</Typography>
                    {jobsType !== 'draft' && job.is_published_to_careers_page && (
                        <ShChip 
                            customSize="xs" 
                            size='small'
                            borderRadius="20px" 
                            bgColor="rgba(76, 175, 80, 0.2)" 
                            textColor="#2E7D32"
                            label="Published to Careers Page"
                        />
                    )}
                </Stack>
                </TableCell>
                {/* <TableCell>
                    <Typography variant="body2">{job.owner}</Typography>
                </TableCell> */}
                {jobsType !== 'template' &&
                    <>
                      <TableCell>
                            <Chip
                                avatar={
                                    <ShAvatar width={25} height={25} backgroundColor={avatarBackgroundColor}>
                                        <Typography variant="subtitle2" color='white'>
                                            {job?.hiring_manager ? job.hiring_manager.at(0) : 'N/A'}
                                        </Typography>
                                    </ShAvatar>
                                }
                                variant="outlined"
                                label={
                                    <Typography variant="caption">
                                        {job?.hiring_manager ? toTitleCase(job.hiring_manager) : 'No Manager'}
                                    </Typography>
                                }
                            />
                        </TableCell>
                        <TableCell>
                            {job.city ? <Typography variant="body2">{job.city}</Typography> :
                                <Typography color={ShGreen} variant="body2"> Remote</Typography>}
                        </TableCell>
                        <TableCell>
                            {job.state ? <Typography variant="body2">{job.state}</Typography> :
                                <Typography color={ShGreen} variant="body2"> Remote</Typography>}
                        </TableCell>
                    </>}

                {jobsType !== 'draft' && jobsType !== 'template' &&
                    <TableCell>
                        {job.starts_at && <Typography variant="body2">
                            {moment(job.starts_at).format("MMM DD, YYYY")}
                        </Typography>}
                    </TableCell>}
                {/* {jobsType === 'expired' &&
                    <TableCell>
                        <Typography variant="body2">
                            {moment(job.ends).format("MMM DD, YYYY")}
                        </Typography>
                    </TableCell>} */}
                <TableCell>
                    <Typography variant="body2">{job.id}</Typography>
                </TableCell>

                {jobsType === 'active' && job.starts_at &&
                    <TableCell>
                        {job.starts_at && (
                            <ShChip
                                borderRadius='15px'
                                size='small'
                                customSize='small'
                                label= {<Typography variant='caption'>{`${remainingDays} Days Left`} </Typography>}
                                bgColor={chipBgColor} 
                                textColor={chipTextColor} 
                                sx={{ marginTop: 1 }}
                            />
                        )}
                    </TableCell>
                }
                <TableCell>
                    <JobActions key={job.id} anchorEl={moreOptionsAnchorEl[job.id]} job={job} jobsType={jobsType}
                        openMoreMenu={openMoreMenu} setMoreOptionsAnchorEl={setMoreOptionsAnchorEl} actionMenuType='popup' />
                </TableCell>
            </ShTableRow>
            {jobsType !== 'draft' &&
                <CollapsibleTableRow >
                    <TableCell colSpan={jobsType === 'active' ? 10 : 9} padding='checkbox'>
                        {jobsSummary[job.id]?.getSummaryStatus === 'pending' && <LinearProgress />}
                        {jobsSummary[job.id]?.getSummaryStatus === 'failed' &&
                            <ShAlert severity="error">{jobsSummary[job.id]?.getSummaryResponse ?? 'Something went wrong!'}</ShAlert>}
                        {jobsSummary[job.id]?.getSummaryStatus === 'success' &&
                            <Collapse in={job.isExpanded} timeout="auto" unmountOnExit>
                                <JobSummary key={job.id} summary={jobsSummary[job.id]} jobsType={jobsType} job={job} />
                                <ThemeColorDivider />
                            </Collapse>
                        }
                    </TableCell>
                </CollapsibleTableRow>}
        </>
    </>);
}

export const JobsTableView = ({ getJobSummary, jobsList, jobsSummary, selectJob, selectedJobs,
    jobsType, sortParams, sortList }: IJobsComponentBase & ISortBase<JobsSortCols>) => {

    useEffect(() => {
        const currRow = document.getElementById(`j_t_v_r_${Number(getUrlSearchParams('jobId'))}`);
        currRow?.setAttribute("tabindex", "0");
        currRow?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        currRow?.focus();
    }, []);


    return (<>
        <ShTableContainer>
            <ShTable size="small">
                <TableHead>
                    <ShTableRow cursor='pointer'>
                        <TableCell className='select-header'></TableCell>
                        <TableCell className='select-header'></TableCell>
                        {/* Sortable constant table headers */}
                        {JobsHeaders.sort((a, b) => a.order - b.order)
                            /*
                                Return undefined for column 'end' if jobsType is not 'expired'.
                                Return undefined for column 'starts_at', 'end' if jobsType is 'draft'.
                                This enables for conditional rendering of the header.
                            */
                            .filter(hdr => jobsType !== 'expired' && hdr.columnName === 'ends' ? undefined :
                                jobsType === 'draft' && (hdr.columnName === 'starts_at' || hdr.columnName === 'ends') ? undefined : hdr)
                            .map((headCell) => (
                                headCell && (!headCell.hideColumnFor?.includes(jobsType)) &&
                                <TableCell key={headCell.columnNameInDb} aria-label={headCell.label}
                                    sortDirection={sortParams?.orderBy === headCell.columnNameInDb ? sortParams?.order : false}>
                                    {/* Show sort option only for enabled columns */}
                                    {headCell.isSortable ?
                                        <ShTableSortLabel
                                            active={sortParams?.orderBy === headCell.columnNameInDb}
                                            direction={sortParams?.orderBy === headCell.columnNameInDb ? sortParams?.order : 'asc'}
                                            onClick={() => sortList(headCell.columnNameInDb ?? 'name', sortParams?.order === 'asc' ? 'desc' : 'asc')}
                                        >
                                            {headCell.label}
                                        </ShTableSortLabel> : <>{headCell.label}</>
                                    }
                                </TableCell>
                            ))}

                        {jobsType === 'active' &&
                            <TableCell aria-label='jobTimeLeft'></TableCell>
                        }

                        <TableCell aria-label='Actions'></TableCell>
                    </ShTableRow>
                </TableHead>
                <Fade in={true} timeout={800}>
                    <TableBody>
                        {jobsList.map((job, index) => (
                            // Row component holds both applicant and collapsible summary rows.
                            <Row key={index} indx={index} getJobSummary={getJobSummary} job={job}
                                jobsSummary={jobsSummary} jobsType={jobsType}
                                selectJob={selectJob} selectedJobs={selectedJobs} />
                        ))}
                    </TableBody>
                </Fade>
            </ShTable>
        </ShTableContainer>
    </>);
};
